import { CommentableEntityType } from "functions/api/notifications/interface";

/**
 * The active context for comment views (Hierarchy, TlfItem, or Toc).
 */
export type CommentViewContext = CommentableEntityType | "Toc";

/**
 * Possible values for the comment filter control.
 */
export type CommentFilterOptionValue = "all" | "resolved" | "open";

/**
 * Status for the comment panel UI.
 */
export interface CommentPanelStatus {
  highlightCommentId: string;
  activeRelatedTo: string;
  showComments: boolean;
  commentFilter: CommentFilterOptionValue;
}

/**
 * Tooltip shown on comment entry points that are disabled while a TLF item is still
 * in its creation phase (i.e. before it has been saved to the database).
 */
export const NEW_TLF_COMMENT_TOOLTIP = "Save the TLF item before adding comments";
